// The version of the generated metadata.
//
// For example, if some new fields are added in some future, this version could be incremented
// in order to signal about a "breaking change" in the generated metadata.
//
export default 4